__turbopack_context__.v({
  "input_text_area": "textare_input-module__t5ZNiG__input_text_area",
});
